// import { EntrepreneurAnnounce10FormContainer } from "../../../containers/SupportSystem/SupportForm/EntrepreneurAnnounce10FormContainer";
import { EntrepreneurCh24Announce10FormContainer } from "../../../containers/SupportSystem/SupportForm/EntrepreneurCh24Announce10FormContainer";
export function EntrepreneurCh24Announce10FormPage() {
    return (
        <EntrepreneurCh24Announce10FormContainer  />
    );

}